var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H12C14.2091 20 16 18.2091 16 16V6.75425C16 6.29587 15.8425 5.8514 15.554 5.49524L11.7022 0.740983C11.3224 0.272273 10.7514 0 10.1482 0H4ZM11.625 3.82283V5.4H12.9028L11.625 3.82283ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H12C13.1046 18 14 17.1046 14 16V7.4H11.625C10.5204 7.4 9.625 6.50457 9.625 5.4V2H4ZM9 12.5L9.4 12.2C9.84183 11.8686 10.4686 11.9582 10.8 12.4C11.1314 12.8418 11.0418 13.4686 10.6 13.8L8.60808 15.2939C8.43959 15.4232 8.22876 15.5 8 15.5C7.77124 15.5 7.56041 15.4232 7.39192 15.2939L5.4 13.8C4.95817 13.4686 4.86863 12.8418 5.2 12.4C5.53137 11.9582 6.15817 11.8686 6.6 12.2L7 12.5V8.61139C7 8.05911 7.44772 7.61139 8 7.61139C8.55229 7.61139 9 8.05911 9 8.61139V12.5Z",
    fill: "#1751D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.fed0b9e9141335325a1d135ddcb05619.svg";
export { ForwardRef as ReactComponent };